export const ERR_TYPE_REQUIRED = 'isrequired';
export const ERR_TYPE_ENUM = 'enum';
export const ERR_TYPE_ENUM_IS_DROPDOWN = 'enumdropdown';
export const ERR_TYPE_NUM_SMALL = 'numtoosmall';
export const ERR_TYPE_NUM_LARGE = 'numtoolarge';
export const ERR_TYPE_STR_SHORT = 'stringtoosmall';
export const ERR_TYPE_STR_LONG = 'stringtoolong';
export const ERR_TYPE_FORCE = 'force';

export const FIELD_TYPE_TXT = 'text';
export const FIELD_TYPE_NUMBER = 'number';
export const FIELD_TYPE_DROPDOWN = 'dropdown';
export const FIELD_TYPE_TXTAREA = 'textarea';
export const FIELD_TYPE_DECISIONTREE = 'decision';
export const FIELD_TYPE_SEARCHABLE_DROPDOWN = 'searchable-dropdown';
